/**
 * Consumption profile of the object (kWh per wall-clock hour, 24 cells): the
 * manual profile when set, otherwise the median of the history. The internal
 * arbitrage plan uses it. `PUT` with values sets it by hand («Зберегти
 * профіль»), with `null` returns to the automatic one.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ExpectedLoadResponse } from 'shared';

import { api } from '../lib/api-client.js';

const url = (siteId: string) => `/api/sites/${encodeURIComponent(siteId)}/expected-load`;

export function useExpectedLoad(siteId: string) {
  return useQuery({
    queryKey: ['expected-load', siteId],
    queryFn: () =>
      api.get<{ expected_load: ExpectedLoadResponse | null }>(url(siteId)).then((r) => r.expected_load),
    enabled: !!siteId,
    staleTime: 10 * 60_000,
  });
}

export function useSaveExpectedLoad(siteId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (hourlyKwh: number[] | null) =>
      api.put<{ expected_load: ExpectedLoadResponse | null }>(url(siteId), { hourly_kwh: hourlyKwh }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['expected-load', siteId] });
      void qc.invalidateQueries({ queryKey: ['site'] });
    },
  });
}
